import { render, staticRenderFns } from "./MyScenario.vue?vue&type=template&id=34fb56bd&scoped=true&"
import script from "./MyScenario.vue?vue&type=script&lang=js&"
export * from "./MyScenario.vue?vue&type=script&lang=js&"
import style0 from "./MyScenario.vue?vue&type=style&index=0&id=34fb56bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb56bd",
  null
  
)

export default component.exports